import { useDossierDataStore } from "@/store/useDossierDataStore";
import { api } from "@/loanLinkApi";
import type { AddressResponse } from "@loanlink-nl/model-app";
import type { ResultType } from "@rocicorp/zero";
import { isEqual } from "es-toolkit";
import type { MaybeRefOrGetter } from "vue";
import { computed, ref, toValue, watch } from "vue";
import { defineStore } from "pinia";

function useAddressMeta(
	addressGetter: MaybeRefOrGetter<AddressResponse | undefined>,
) {
	const address = computed(() => toValue(addressGetter));
	const addressMeta = ref();
	const status = ref<ResultType>("unknown");

	watch(
		address,
		async (address, oldAddress) => {
			if (isEqual(address, oldAddress) && addressMeta.value) {
				return;
			}

			addressMeta.value = undefined;
			if (address?.adresseerbaarObjectIdentificatie) {
				const meta = await getAddressMeta(
					address.adresseerbaarObjectIdentificatie,
				);
				addressMeta.value = meta;
			}

			status.value = "complete";
		},
		{ immediate: true, deep: true },
	);

	return { data: addressMeta, status };

	async function getAddressMeta(id: string) {
		const { data } = await api.address.addressList(id);
		return data;
	}
}

export const useAddressMetaStore = defineStore("useAddressMetaStore", () => {
	const dossierDataStore = useDossierDataStore();

	const { data, status } = useAddressMeta(
		() => dossierDataStore.data?.objectData?.address,
	);

	return { data, status };
});
